import {
    CopyBrief as CopyBriefMutationInterface,
    CopyBriefVariables,
} from '__generated__/CopyBrief';
import React from 'react';
import { Mutation, MutationFetchResult, MutationResult } from 'react-apollo';
import mutation from './CopyBrief.graphql';

interface Props {
    children: (
        copyBrief: (
            variables: CopyBriefVariables
        ) => Promise<void | MutationFetchResult<CopyBriefMutationInterface>>,
        result: MutationResult
    ) => React.ReactElement;
}

class CopyBrief extends React.Component<Props> {
    render() {
        const { children } = this.props;
        return (
            <Mutation<CopyBriefMutationInterface, CopyBriefVariables> mutation={mutation}>
                {(mutation, result) => {
                    return children(
                        variables =>
                            mutation({ variables }).catch(e => {
                                this.setState(() => {
                                    throw e;
                                });
                            }),
                        result
                    );
                }}
            </Mutation>
        );
    }
}

export default CopyBrief;
